import { combineReducers } from "redux";
import CartReducer from "./createReducer";
import productReducer from "./ProductReducer";

import ValueReducer from "./valueReducer";

const rootReducer = combineReducers({
  CartReducer: CartReducer,
  ValueReducer: ValueReducer,
  productReducer: productReducer,
});
export default rootReducer;
